import AppNavigation from '@ms/yammer-web-components/dist/navigation/AppNavigation';
import { useUIFeatures } from '@ms/yammer-web-ui-features/dist/features';
import React, { ReactNode, useCallback } from 'react';

type UseLeftSidebarCallback = () => () => ReactNode;
export const useLeftSidebarCallback: UseLeftSidebarCallback = () => {
  const isLeftSidebarEnabled = useUIFeatures((features) => features.navigation?.leftSidebar);

  return useCallback(() => (isLeftSidebarEnabled ? <AppNavigation /> : null), [isLeftSidebarEnabled]);
};
